import React, { useRef, useState, useEffect } from 'react';
import { motion, useScroll, useTransform, Variants, AnimatePresence } from 'framer-motion';
import './ServicesSection.css';

// Helper function to wrap punctuation and numbers with default font
const wrapWithDefaultFont = (text: string) => {
  return text.split(/([.,;:!?'"()[\]{}0-9]+)/).map((part, index) => {
    if (/[.,;:!?'"()[\]{}]/.test(part) || /\d/.test(part)) {
      return <span key={index} className="default-font">{part}</span>;
    }
    return part;
  });
};

const services = [
  {
    id: 'silver',
    label: 'SILVER',
    title: 'Silver Package',
    description: 'Budget Friendly – Ideal for Small Weddings',
    accent: 'BASIC COVERAGE',
    variants: {
      singleSide: {
        title: 'Silver - Single Side',
        price: '₹24,999/-',
        features: [
          'Wedding Coverage – 1 Photographer + 1 Cinematographer',
          'Reception Coverage – 1 Photographer + 1 Cinematographer',
          'All JPEG Photos + 25 Edited Photos',
          'Wedding Teaser – 1',
          'Wedding Cinematic Video – Up to 30 Minutes',
          '1 Standard Album (12/36) – 20 Pages with 80 Photos',
          'Storage Device – 16 GB',
          'Closing Greetings from Our Team'
        ]
      },
      bothSides: {
        title: 'Silver - Both Sides',
        price: '₹24,999/-',
        features: [
          
          'All wedding & reception JPEG photos',
          '25 professionally edited images',
        
          '1 Wedding Teaser video',
          'Wedding Cinematic Video up to 30 minutes',
          '1 Standard Quality Album (12/36)',
          '20 Pages with 80 Photos',
          '✅ Delivery via Pendrive',
          '❌ Travel, food & accommodation not included'
        ]
      }
    }
  },
  {
    id: 'golden',
    label: 'GOLD',
    title: 'Golden Package',
    description: 'Comprehensive coverage for your special day with premium features',
    accent: 'PREMIUM COVERAGE',
    variants: {
      singleSide: {
        title: 'Golden - Single Side',
        price: '₹34,999/-',
        features: [
          'Wedding Coverage – 1 Photographer + 1 Cinematographer',
          'Bidaai & Boron – 1 Photographer + 1 Cinematographer',
          'Reception Coverage – 1 Photographer + 1 Cinematographer',
          '1 Album (12/36) with Mini Book – 20 Pages with 100 Photos',
          '50–60 Minutes Cinematic Video',
          'Storage Device – 32 GB',
          'Closing Greetings from Our Team'
        ]
      },
      bothSides: {
        title: 'Golden - Both Sides',
        price: '₹34,999/-',
        features: [
    
          'All JPEGs + 30 Edited Pre-Wedding Photos',
          'All JPEGs + 40 Edited Wedding & Reception Photos',
          'All event images provided',
         
          'Bride Outdoor Video – 1',
          'Wedding Teaser – 1 + 4 Reels',
          'Wedding Cinematic Video up to 45 minutes',
          
          '1 Standard Album (12/36) – 40 Pages with 200 Photos',
          '1 Standard Mini Book (6/9)',
          '✅ Delivery via Pendrive',
          '❌ Travel, food & accommodation not included'
        ]
      }
    }
  },
  {
    id: 'platinum',
    label: 'PLATINUM',
    title: 'Platinum Package',
    description: 'Premium coverage with extended hours and additional features',
    accent: 'ELITE COVERAGE',
    variants: {
      singleSide: {
        title: 'Platinum - Single Side',
        price: '₹44,999/-',
        features: [
          'Ring Ceremony & Mehendi Shoot – 1P + 1C',
          'Wedding Coverage – 1P + 1C',
          'Bidaai & Boron – 1P + 1C',
          'Reception Coverage – 1P + 1C',
          '20 Edited Event Photos (Pre/Post Wedding Included)',
          '1 Album (14/40) with Mini Book – 25 Pages with 120 Photos',
          'Short Cinematic Highlights – 3–4 Minutes',
          'Pre/Post Wedding Photo & Video',
          '50–60 Minutes Cinematic & Traditional Video',
          'Two Storage Devices – 32 GB each',
          'Closing Greetings from Our Team'
        ]
      },
      bothSides: {
        title: 'Platinum - Both Sides',
        price: '₹44,999/-',
        features: [
          
          'All JPEGs + 20 Edited Pre-Wedding Photos',
          'All JPEGs + 60 Edited Wedding & Reception Photos',
          'All event photos provided',
         
          'Pre-Wedding Video – 3–4 Minutes',
          'Bride Outdoor Video – 1',
          'Wedding Teaser – 1 + 6 Reels',
          'Short Cinematic Highlights – 3–4 Minutes',
          'Wedding Cinematic Video up to 45 minutes',
         
          '1 Premium Album (14/40 or 12/36) – 50 Pages with 240 Photos',
          '1 Premium Mini Book (6/12)',
          '✅ Delivery via Pendrive',
          '❌ Travel, food & accommodation not included'
        ]
      }
    }
  },
  {
    id: 'diamond',
    label: 'DIAMOND',
    title: 'Diamond Package',
    description: 'The ultimate wedding coverage with premium features and extended team',
    accent: 'LUXURY COVERAGE',
    variants: {
      singleSide: {
        title: 'Diamond - Single Side',
        price: '₹54,999/-',
        features: [
          'Ring Ceremony & Mehendi – 1P + 1C',
          'Wedding Coverage – 3P + 3C',
          'Bidaai & Bodhuboron – 2P + 2C',
          'Reception Coverage – 3P + 3C',
          '50 Edited Event Photos (Pre/Post Wedding Included)',
          '1 Premium Album (14/40) with Mini Book – 30 Pages with 150 Photos',
          'Pre-Wedding Album – 15 Pages with 50 Photos',
          'Wedding Invitation Video',
          'Short Cinematic Highlights – 3–4 Minutes',
          'Pre/Post Wedding Photo & Video',
          '50–60 Minutes Cinematic & Traditional Video',
          'Storage Device – 64 GB',
          'Closing Greetings from Our Team'
        ]
      },
      bothSides: {
        title: 'Diamond - Both Sides',
        price: '₹54,999/-',
        features: [
          
          'All JPEGs + 40 Edited Pre-Wedding Photos',
          'All JPEGs + 80 Edited Wedding Photos',
          'All event photos provided',
         
          'Pre-Wedding Teaser & Film – 3–4 Minutes',
          'Wedding Invitation Video',
          'Wedding Teaser – 1 + 8 Reels',
          'Short Cinematic Highlights – 3–4 Minutes',
          'Wedding Cinematic Video up to 45 minutes',
          'Bride Outdoor Video – 1',
          'Couple Video – 1',
          
          '1 Premium Canvera Album – 60 Pages with 300 Photos',
          '1 Premium Mini Book',
          '1 Pre-Wedding Album – 15 Pages with 50 Photos',
          '✅ Drone Included for Pre-Wedding',
          '✅ Delivery via Pendrive',
          '❌ Travel, food & accommodation not included'
        ]
      }
    }
  }
];

const ServicesSection: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const [expandedCard, setExpandedCard] = useState<string | null>(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start'],
  });

  const titleY = useTransform(scrollYProgress, [0.05, 0.25], [60, 0]);
  const titleOpacity = useTransform(scrollYProgress, [0.05, 0.25], [0, 1]);

  const haloScale = useTransform(scrollYProgress, [0.1, 0.4], [0.8, 1.05]);
  const haloOpacity = useTransform(scrollYProgress, [0.1, 0.4], [0, 1]);

  const openModal = (serviceId: string) => {
    console.log('Opening modal for:', serviceId);
    setActiveModal(serviceId);
    setExpandedCard(null); // Collapse any expanded card
    // Store current scroll position
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setActiveModal(null);
    // Restore scroll position
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  };

  const toggleCard = (serviceId: string) => {
    if (expandedCard === serviceId) {
      setExpandedCard(null); // Collapse if already expanded
    } else {
      setExpandedCard(serviceId); // Expand new card, auto-collapse others
    }
  };

  const cardVariants: Variants = {
    hidden: { opacity: 0, y: 80, rotate: 0 },
    visible: (index: number) => ({
      opacity: 1,
      y: 0,
      rotate: index % 2 === 0 ? 0 : 0,
      transition: {
        duration: 0.8,
        delay: index * 0.12,
        ease: 'easeOut'
      }
    })
  };

  return (
    <section className="services-section" id="services" ref={sectionRef}>
      <div className="services-inner">
        <motion.div
          className="services-header"
          style={{ y: titleY, opacity: titleOpacity }}
        >
          <p className="services-eyebrow">SIGNATURE OFFERINGS</p>
          <h2 className="services-title">
            CRAFTED <span className="title-accent">FOR YOUR STORY</span>
          </h2>
          <p className="services-subcopy">
            {wrapWithDefaultFont("Weddings, pre-weddings, engagements and events — each experience is designed as a cinematic chapter in the larger story of your love.")}
          </p>
        </motion.div>

        <div className="services-stage">
          <motion.div
            className="services-halo"
            style={{ scale: haloScale, opacity: haloOpacity }}
          />

          <div className="services-grid">
            {services.map((service, index) => (
              <motion.article
                key={service.id}
                className={`service-card service-card-${index + 1} ${expandedCard === service.id ? 'expanded' : ''}`}
                custom={index}
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
              >
                <div className="service-label-row">
                  <span className="service-index">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="service-label">{service.label}</span>
                  <span className="service-pill">Z26</span>
                </div>

                <h3 className="service-heading">{wrapWithDefaultFont(service.title)}</h3>

                <p className="service-description">
                  {wrapWithDefaultFont(service.description)}
                </p>

                <div className="service-meta-row">
                  <span className="service-accent">{service.accent}</span>
                  <button className="service-cta" type="button" onClick={(e) => {
                    e.stopPropagation();
                    openModal(service.id);
                  }}>
                    <span>DETAILS</span>
                    <span className="service-arrow">↗</span>
                  </button>
                </div>

                {/* Dropdown content */}
                <AnimatePresence>
                  {expandedCard === service.id && (
                    <motion.div
                      className="service-dropdown"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: 'easeInOut' }}
                    >
                      <div className="dropdown-content">
                        <h4>{wrapWithDefaultFont("Package Options")}</h4>
                        <div className="package-options">
                          <div className="option">
                            <h5>{wrapWithDefaultFont("Single Side")}</h5>
                            <span className="option-price">{wrapWithDefaultFont(service.variants.singleSide.price)}</span>
                          </div>
                          <div className="option">
                            <h5>{wrapWithDefaultFont("Both Sides")}</h5>
                            <span className="option-price">{wrapWithDefaultFont(service.variants.bothSides.price)}</span>
                          </div>
                        </div>
                        <div className="dropdown-price">
                          <span className="price-label">{wrapWithDefaultFont("Starting from")}</span>
                          <span className="price-amount">{wrapWithDefaultFont(service.variants.singleSide.price)}</span>
                        </div>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.article>
            ))}
          </div>
        </div>
      </div>

      {/* Package Modal */}
      <AnimatePresence>
        {activeModal && (
          <motion.div
            className="package-modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeModal}
          >
            <motion.div
              className="package-modal"
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              onClick={(e) => e.stopPropagation()}
            >
              <PackageModalContent 
                service={services.find(s => s.id === activeModal)!}
                onClose={closeModal}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Custom Package CTA */}
      <div className="services-custom-cta">
        <button className="cta-see-packages-btn" onClick={() => window.location.href = 'tel:+917908086574'}>
          <span className="cta-phone-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
          </span>
          <span>CUSTOM PACKAGE</span>
        </button>
      </div>
    </section>
  );
};

const PackageModalContent: React.FC<{
  service: typeof services[0];
  onClose: () => void;
}> = ({ service, onClose }) => {
  const [activeTab, setActiveTab] = useState('singleSide');
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);
  const indicatorRef = useRef<HTMLDivElement>(null);

  const minSwipeDistance = 50;
  const tabs = ['singleSide', 'bothSides'];

  const updateIndicator = (tabId: string) => {
    if (indicatorRef.current) {
      const activeButton = document.querySelector(`.tab-button[data-tab="${tabId}"]`) as HTMLButtonElement;
      if (activeButton) {
        indicatorRef.current.style.width = `${activeButton.offsetWidth}px`;
        indicatorRef.current.style.left = `${activeButton.offsetLeft}px`;
      }
    }
  };

  useEffect(() => {
    updateIndicator(activeTab);
  }, [activeTab]);

  const onTouchStart = (e: React.TouchEvent) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      // Swipe left - go to next tab
      const currentIndex = tabs.indexOf(activeTab);
      if (currentIndex < tabs.length - 1) {
        setActiveTab(tabs[currentIndex + 1]);
      }
    } else if (isRightSwipe) {
      // Swipe right - go to previous tab
      const currentIndex = tabs.indexOf(activeTab);
      if (currentIndex > 0) {
        setActiveTab(tabs[currentIndex - 1]);
      }
    }
  };

  return (
    <div 
      className="package-modal-content"
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <div className="package-modal-header">
        <h2 className="package-modal-title">{service.title}</h2>
      </div>

      <div className="package-tabs">
        <div className="tab-indicator" ref={indicatorRef}></div>
        <button
          className={`tab-button ${activeTab === 'singleSide' ? 'active' : ''}`}
          data-tab="singleSide"
          onClick={() => setActiveTab('singleSide')}
        >
          Single Side
        </button>
        <button
          className={`tab-button ${activeTab === 'bothSides' ? 'active' : ''}`}
          data-tab="bothSides"
          onClick={() => setActiveTab('bothSides')}
        >
          Both Sides
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'singleSide' && (
          <div className="variant-content">
            <div className="variant-header">
              <h3>{wrapWithDefaultFont("Single Side Coverage")}</h3>
            </div>
            <div className="features-list">
              {service.variants.singleSide.features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>{wrapWithDefaultFont(feature)}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'bothSides' && (
          <div className="variant-content">
            <div className="variant-header">
              <h3>{wrapWithDefaultFont("Both Sides Coverage")}</h3>
            </div>
            <div className="features-list">
              {service.variants.bothSides.features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <span className="feature-check">✓</span>
                  <span>{wrapWithDefaultFont(feature)}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="package-modal-footer">
        <button className="package-cta-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default ServicesSection;
